<div class="checkbox" [class.checked]="checked" [class.disabled]="disabled">
  <svg
    class="check"
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.13247 6.27813L1.09081 4.23647C0.982976 4.1273 0.83592 4.06585 0.682474 4.06585C0.529028 4.06585 0.381972 4.1273 0.274141 4.23647C0.0466406 4.46397 0.0466406 4.82563 0.274141 5.05313L2.71831 7.4973C2.94581 7.7248 3.31331 7.7248 3.54081 7.4973L9.72414 1.3198C9.95164 1.0923 9.95164 0.730634 9.72414 0.503134C9.61631 0.393964 9.46925 0.33252 9.31581 0.33252C9.16236 0.33252 9.0153 0.393964 8.90747 0.503134L3.13247 6.27813Z"
      fill="#FDFDFD" />
  </svg>
</div>
